import TypingAnimation from "./TypingAnimation";
import ParticlesBackground from "./ParticlesBackground";
import homebanner from '../static/img/profile-banner.png';

const Title = () => {
  return (
    <section id="home" data-nav-tooltip="Home" className="pp-section pp-scrollable">
      <div className="home-banner">
        <ParticlesBackground />
        <div className="container">
          <div className="row full-screen align-items-center">
            <div className="col-lg-6">
              <div className="type-box">
                <h6>Hola!!, mi nombre es </h6>
                <h1 className="font-alt">Frank Moisés</h1>                
                <p className="lead">Soy un apasionado <span id="type-it"><TypingAnimation /></span></p>
                <p className="desc">Creo sitios y servicios web modernos y elegantes para clientes de todos los tamaños. Asimismo, planifico entrenamientos personalizados, ya sea de forma presencial u online, y además creo experiencias de fitness grupal todos los días.</p>
                <div className="btn-bar">
                  <a className="px-btn px-btn-theme" href="https://github.com/Frankmoises7/Frankmoises7/blob/master/cv/Frank_Islas_CV.pdf?raw=true" rel='noreferrer'>Download CV</a>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hb-img"><img src={homebanner} title="" alt="" /></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Title;
